export default "__VITE_PUBLIC_ASSET__7afbd620__"